<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="auto"
      no-padding
      :content-style="{padding: '16px 20px 0px 20px'}"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :loading="loading"
      :footer="!viewOpType"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      {{opType | optionText(OpEnum.typeOption)}}物流商
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="inputWidth" />
        <gj-input v-model="longInputWidth" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="8">
            <el-form-item
                label="物流商编码"
                prop="code"
                :rules="[
                  { required: true, message: '请输入物流商编码', trigger: ['change'] },
                ]">
              <gj-input
                  v-model="form.code"
                  :width="inputWidth"
                  placeholder="物流商编码（唯一）"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="物流商名称"
                prop="name"
                :rules="[
                  { required: true, message: '请输入物流商名称', trigger: ['change'] },
                ]">
              <gj-input
                  v-model="form.name"
                  :width="inputWidth"
                  placeholder="物流商名称"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="状态"
                prop="status"
                :rules="[
                  $gjRequired('请选择状态')
                ]">
              <gj-select
                  v-model="form.status"
                  :width="inputWidth"
                  :options="option.status"
                  :clearable="false"
                  placeholder="状态"
              ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
                label="物流员"
                prop="logisticsUserId"
                :rules="[
                  { required: true, message: '请选择物流员', trigger: ['change'] },
                ]">
              <gj-creator-select
                  v-model="form.logisticsUserId"
                  :width="inputWidth"
                  active
                  placeholder="物流员"
              ></gj-creator-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="物流商联系人"
                prop="contact">
              <gj-input
                  v-model="form.contact"
                  :width="inputWidth"
                  placeholder="物流商联系人"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="联系人电话"
                prop="contactPhone"
                :rules="[
                  $gjReRule(RE.phone, '请输入正确的手机号码')
                ]">
              <gj-input
                  v-model="form.contactPhone"
                  :width="inputWidth"
                  placeholder="联系人电话"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <gj-area-title>收款信息</gj-area-title>
        <el-row>
          <el-col :span="8">
            <el-form-item
                label="收款方"
                prop="payee">
              <gj-input
                  v-model="form.payee"
                  :width="inputWidth"
                  placeholder="收款方"
              ></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
                label="银行名称"
                prop="bankName">
              <gj-input
                  v-model="form.bankName"
                  width="500px"
                  placeholder="银行名称"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
            label="银行账号"
            prop="bankAccount">
          <gj-input
              v-model="form.bankAccount"
              :width="longInputWidth"
              placeholder="银行账号">
          </gj-input>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn, opTypeMixin, responseMixin} from "../../../../../minxins";
  import {OpEnum} from "../../../../../utils/options";
  import {LogisticsProviderEnum} from "../enum";
  import {addLogisticsProvider, getLogisticsProvider, updateLogisticsProvider} from "../../../../../api/logistics";

  export default {
    name: "app-op-logistics-provider-modal",
    mixins: [modalMixIn, formRuleMixin, responseMixin, opTypeMixin],
    props: {
      item: {
        default: null
      },
      opType: {
        required: true
      }
    },
    data() {
      return {
        form: {
          id: null,
          code: null,
          name: null,
          status: null,
          logisticsUserId: null,
          contact: null,
          contactPhone: null,
          payee: null,
          bankName: null,
          bankAccount: null
        },
        labelWidth: '100px',
        inputWidth: '200px',
        longInputWidth: '800px',
        OpEnum: OpEnum,
        option: {
          status: LogisticsProviderEnum.statusOption
        },
        loading: false
      }
    },
    created() {
      if (this.addOpType) {
        this.form.status = LogisticsProviderEnum.status.ENABLE;
      } else if (this.editOpType) {
        this.loading = true;
        getLogisticsProvider(this.item.id)
          .then(data => {
            Object.assign(this.form, data);
          })
          .complete(() => this.loading = false)
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          if (this.addOpType) {
            addLogisticsProvider(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('添加成功');
                  this.$emit('created');
                });
              })
              .complete(() => this.confirmLoading = false);
          } else if (this.editOpType) {
            updateLogisticsProvider(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('更新成功');
                  this.$emit('updated');
                  this.$gjDestroy();
                });
              })
              .complete(() => this.confirmLoading = false);
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .gj-area-title {
    margin-top: 9px;
    &:first-child{ // 直接写last 不生效
      margin-top: 0;
    }
  }
</style>
